'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n      background-image: linear-gradient(to bottom, ', ', ', '),\n        linear-gradient(to top, ', ', ', '),\n        linear-gradient(to bottom, ', ', ', '),\n        linear-gradient(to top, ', ', ', ');\n      background-position: top, bottom, top, bottom;\n      background-size: 100% 4em, 100% 4em, 100% 1em, 100% 1em;\n      overflow-x: hidden;\n      overflow-y: auto;\n    '], ['\n      background-image: linear-gradient(to bottom, ', ', ', '),\n        linear-gradient(to top, ', ', ', '),\n        linear-gradient(to bottom, ', ', ', '),\n        linear-gradient(to top, ', ', ', ');\n      background-position: top, bottom, top, bottom;\n      background-size: 100% 4em, 100% 4em, 100% 1em, 100% 1em;\n      overflow-x: hidden;\n      overflow-y: auto;\n    ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    background-image: linear-gradient(to right, ', ', ', '),\n      linear-gradient(to left, ', ', ', '),\n      linear-gradient(to right, ', ', ', '),\n      linear-gradient(to left, ', ', ', ');\n    background-position: 0 0, 100% 0, 0 0, 100% 0;\n    background-size: 4em 100%, 4em 100%, 1em 100%, 1em 100%;\n    overflow-x: auto;\n    overflow-y: hidden;\n  '], ['\n    background-image: linear-gradient(to right, ', ', ', '),\n      linear-gradient(to left, ', ', ', '),\n      linear-gradient(to right, ', ', ', '),\n      linear-gradient(to left, ', ', ', ');\n    background-position: 0 0, 100% 0, 0 0, 100% 0;\n    background-size: 4em 100%, 4em 100%, 1em 100%, 1em 100%;\n    overflow-x: auto;\n    overflow-y: hidden;\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n  background-attachment: local, local, scroll, scroll;\n  background-repeat: no-repeat;\n'], ['\n  background-attachment: local, local, scroll, scroll;\n  background-repeat: no-repeat;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  ', ';\n  ', ';\n\n  & > :last-child {\n    margin-bottom: 0;\n  }\n'], ['\n  ', ';\n  ', ';\n\n  & > :last-child {\n    margin-bottom: 0;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Color = require('../core/Color');

var _colors = require('HubStyleTokens/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var USE_CLASSES = {
  default: '',
  island: 'is--island'
};

var scrollShadowGradient = function scrollShadowGradient(direction) {
  if (direction === 'vertical') {
    return (0, _styledComponents.css)(_templateObject, _colors.OLAF, (0, _Color.rgba)(_colors.OLAF, 0), _colors.OLAF, (0, _Color.rgba)(_colors.OLAF, 0), _colors.KOALA, (0, _Color.rgba)(_colors.KOALA, 0), _colors.KOALA, (0, _Color.rgba)(_colors.KOALA, 0));
  }
  return (0, _styledComponents.css)(_templateObject2, _colors.OLAF, (0, _Color.rgba)(_colors.OLAF, 0), _colors.OLAF, (0, _Color.rgba)(_colors.OLAF, 0), _colors.KOALA, (0, _Color.rgba)(_colors.KOALA, 0), _colors.KOALA, (0, _Color.rgba)(_colors.KOALA, 0));
};

var scrollShadowContainer = (0, _styledComponents.css)(_templateObject3);

var ScrollWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'UISection__ScrollWrapper'
})(_templateObject4, function (props) {
  return props.overhang ? scrollShadowContainer : null;
}, function (props) {
  return props.overhang ? scrollShadowGradient(props.overhangDirection) : null;
});

var UISection = _react2.default.createClass({
  displayName: 'UISection',

  propTypes: {
    children: _react.PropTypes.node,
    className: _react.PropTypes.string,
    overhang: _react.PropTypes.bool.isRequired,
    overhangDirection: _react.PropTypes.oneOf(['horizontal', 'vertical']).isRequired,
    use: _react.PropTypes.oneOf(Object.keys(USE_CLASSES)).isRequired,
    role: _react.PropTypes.string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      overhang: false,
      overhangDirection: 'horizontal',
      use: 'default'
    };
  },
  getClassName: function getClassName() {
    var _props = this.props,
        className = _props.className,
        overhang = _props.overhang,
        overhangDirection = _props.overhangDirection,
        use = _props.use;

    return (0, _reactUtils.classNames)('is--module', USE_CLASSES[use], className, 'namespaced-hack-section', {
      'private-scroll__wrapper--horizontal namespaced-hack-section--horizontal': overhang && overhangDirection === 'horizontal',
      'namespaced-hack-section--vertical': overhang && overhangDirection === 'vertical'
    });
  },
  render: function render() {
    var _props2 = this.props,
        children = _props2.children,
        overhang = _props2.overhang,
        overhangDirection = _props2.overhangDirection,
        use = _props2.use,
        role = _props2.role,
        rest = _objectWithoutProperties(_props2, ['children', 'overhang', 'overhangDirection', 'use', 'role']);

    var computedRole = role === undefined && overhang ? 'region' : role;

    return _react2.default.createElement(
      ScrollWrapper,
      _extends({}, rest, {
        className: this.getClassName(),
        overhang: overhang,
        overhangDirection: overhangDirection,
        role: computedRole,
        tabIndex: overhang ? '0' : null,
        use: use
      }),
      children
    );
  }
});

exports.default = UISection;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/section/UISection.js
// module id = 135
// module chunks = 0